/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpServersGet } from "../funcs/mcpServersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { McpServer } from "../models/components/mcpserver.js";
import {
  GetMcpServerRequest,
  GetMcpServerSecurity,
} from "../models/operations/getmcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type GetMcpServerQueryData = McpServer;

export function prefetchGetMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetMcpServerRequest | undefined,
  security?: GetMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetMcpServerQuery(
  client$: GramCore,
  request?: GetMcpServerRequest | undefined,
  security?: GetMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyGetMcpServer({
      id: request?.id,
      slug: request?.slug,
      toolsetId: request?.toolsetId,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getMcpServerQueryFn(
      ctx,
    ): Promise<GetMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(mcpServersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetMcpServer(
  parameters: {
    id?: string | undefined;
    slug?: string | undefined;
    toolsetId?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "mcpServers", "get", parameters];
}
